export const casementsDependencyKeys = ['window-hand', 'aeration', 'children-security']
